/**
 * Перелік адрес листа так, як його чекає бек (`SPEC-013` §4.4): нижній
 * регістр, без пробілів по краях, без порожніх і без повторів.
 *
 * Приймає й рядок через кому чи крапку з комою — так адреси вставляють
 * із пошти одним рядком. Порядок першої появи зберігається.
 */
export const normalizeAddresses = (value: unknown): string[] => {
    const raw: unknown[] = Array.isArray(value) ? value : typeof value === 'string' ? [value] : []
    const result: string[] = []

    for (const item of raw) {
        if (typeof item !== 'string') continue

        for (const part of item.split(/[,;\s]+/)) {
            const address = part.trim().toLowerCase()

            if (address !== '' && !result.includes(address)) result.push(address)
        }
    }

    return result
}

/**
 * Підказка адресата: пошта й чия вона — «Петренко Іван», «Клієнт».
 * Значення поля — сама адреса; підпис лише допомагає вибрати.
 */
export interface LetterRecipientOption {
    value: string
    label: string
}

/**
 * Підказки поля адрес: пошти контрагента, далі — його контактів (з ім'ям).
 * Повтори прибираються — та сама адреса з іменем контакту виграє, бо так її
 * впізнати легше.
 */
export const recipientOptions = (
    ownerTitle: string | null,
    ownerEmails: unknown,
    contacts: ReadonlyArray<{ title?: string | null; email?: string | null }>
): LetterRecipientOption[] => {
    const byAddress = new Map<string, string>()

    for (const contact of contacts) {
        for (const address of normalizeAddresses(contact.email)) {
            const name = typeof contact.title === 'string' && contact.title.trim() !== '' ? contact.title.trim() : address

            byAddress.set(address, `${name} · ${address}`)
        }
    }

    const ownerLabel = ownerTitle !== null && ownerTitle.trim() !== '' ? ownerTitle.trim() : null
    const ownerOptions = normalizeAddresses(ownerEmails)
        .filter((address) => !byAddress.has(address))
        .map((address) => ({ value: address, label: ownerLabel ? `${ownerLabel} · ${address}` : address }))

    return [...ownerOptions, ...Array.from(byAddress, ([value, label]) => ({ value, label }))]
}
